import type { ArgoCDApplicationResource, TenantResource } from "@octopusdeploy/octopus-server-client";
import { ExpandingTagList } from "~/areas/infrastructure/components/ArgoCDInstances/components/ExpandingTagList";
import { tenantTagList } from "~/components/Tag";
type ArgoCDApplicationTenantsTagListProps = {
    application: ArgoCDApplicationResource;
    tenants: TenantResource[];
};
export const ArgoCDApplicationTenantsTagList = (props: ArgoCDApplicationTenantsTagListProps) => {
    const tenantIds = [...new Set(props.application.Sources.map((src) => src.TenantId).filter((id) => id !== null))];
    return <ExpandingTagList singularName={"tenant"} ids={tenantIds} renderTagList={(ids) => tenantTagList(props.tenants, ids)}/>;
};
